import type { JSONContent } from '@tiptap/core'
import type { TmWrappers } from '@/wrappers'

export type TemplatePostBody = {
  id?: string
  name: string
  content: string
  emailContent: string
  category: number
}

export const templatesEditCategoryModalId: TmWrappers = 'templatesEditCategory'

export type TemplatesCategoryEditPostBody = {
  templateIds: string[]
  allTemplates: boolean
}

export type TemplateSharePostBody = {
  templateIds: string[]
  allTemplates: boolean
  subaccountIds: string[]
  allSubaccounts: boolean
}

export const templateCategoryModalId: TmWrappers = 'templateCategory'

export type TemplateCategoryPostBody = {
  name: string
}

export type TemplateCategorySortBody = {
  categories: Set<string>
}

export type TemplateSidebarActions = 'rename' | 'delete'

export const templateCategoryDeleteModalId: TmWrappers = 'templateCategoryDelete'

export type TemplateCategoryDeleteBody = {
  id: string
  newCategoryId: string
}

export const allTemplatesTranslateKey = 'pageTitle.user.allTemplates'

export interface TemplateFormScheme {
  name: string
  content: JSONContent
  emailContent: JSONContent
  categoryId: string
}

export const emailTemplateContentFieldName = 'body' as const
export type TemplateEmailFormSchema = {
  name: string
  [emailTemplateContentFieldName]: string
  categoryId: string
}

export type TemplatesFilters = 'category'
